import { defineComponent as p, computed as a } from "vue";
import t from "./index40.js";
import { MsAddFilled as m, MsRemoveFilled as r, MsRemove as i, MsAdd as s } from "@sunrise/icons";
const c = p({
  name: "CsExpander",
  components: {
    CsSecondaryButton: t,
    MsAdd: s,
    MsRemove: i,
    MsRemoveFilled: r,
    MsAddFilled: m
  },
  model: {
    prop: "expanded",
    event: "update:expanded"
  },
  props: {
    expanded: Boolean
  },
  emits: ["update:expanded"],
  setup(e, { emit: n }) {
    const d = a(() => e.expanded ? "Weniger anzeigen" : "Mehr anzeigen");
    function o() {
      n("update:expanded", !e.expanded);
    }
    return {
      label: d,
      onClick: o
    };
  }
});
export {
  c as default
};
